import React from 'react';
import { icons } from '../icons';

type KoobPromptSuggestionProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className' | 'type'
>;

/**
 * A suggested question to send to an assistant in one click: a plain row,
 * the question then a chevron. Stack them in a column.
 */
const KoobPromptSuggestion = React.forwardRef<
  HTMLButtonElement,
  KoobPromptSuggestionProps
>(({ children, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className="group flex w-full cursor-pointer items-center justify-between gap-3 rounded-md border-none bg-transparent px-2 py-1.5 text-left text-[13px] text-foreground transition-colors hover:bg-brand/5 hover:text-brand focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
    {...props}
  >
    <span>{children}</span>
    <i
      className={`${icons.chevronRight} shrink-0 text-[10px] text-muted-foreground group-hover:text-brand`}
      aria-hidden="true"
    />
  </button>
));

KoobPromptSuggestion.displayName = 'KoobPromptSuggestion';

export default KoobPromptSuggestion;
